import React from "react";
import ProfileRight from "../RightPanel/ProfileRight";
import AddPostRight from "../RightPanel/AddPostRight";
import { Link } from "react-router-dom";
import { auth } from "../service/firebase";

function Rightside() {
  const toTop = () =>
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  return (
    <div className="ml-2 position-fixed d-flex flex-column align-items-center justify-content-around h-75 w-25 ">
      <ProfileRight />
      <AddPostRight />
      <Link to="/userprofile">
        <button
          type="button"
          className="btn btn-primary"
          disabled={!auth?.currentUser?.displayName}
        >
          Profile
        </button>
      </Link>
      <Link to="/menu">
        <button type="button" className="btn btn-primary">
          All Users
        </button>
      </Link>
      <button type="button" className="btn btn-outline-dark" onClick={toTop}>
        Top
      </button>
    </div>
  );
}

export default Rightside;
